<div class="filters_view_bg" [hidden]="!searchDropDownToggle" (click)="searchDropDownToggle = false"></div>
<div class="search-path">
    <button class="btn btn-primary" (click)="searchDropDownToggle = !searchDropDownToggle">
        Filter
    </button>
    <div class="searchDropdown" [hidden]="!searchDropDownToggle" style="z-index: 51;">
        <form [formGroup]="searchForm" autocomplete="off" (ngSubmit)="onSubmit()" (keydown.enter)="handleEnter($event)">
            <!-- Customer Dropdown (Visible based on Input) -->
            <!-- <div *ngIf="showCustomer === true" class="dropdownFields">
                <label>Customer</label>
                <ng-select [items]="customerModel"  bindValue="id" placeholder="Select a customer"
                    formControlName="CUSTOMER" appendTo="body">
                </ng-select>
            </div> -->

            <!-- Emp Name -->
            <div *ngIf="showEmpName=== true" class="dropdownFields">
                <label>Employee Name</label>
                <input type="text" class="form-control" formControlName="NAME_IN" placeholder="Enter Employee Name">
            </div>

            <!-- Location Name -->
            <div *ngIf="showLocationName=== true" class="dropdownFields">
                <label>Location Name</label>
                <input type="text" class="form-control" formControlName="LOCATION_NAME_IN" placeholder="Enter Location Name">
            </div>

            <!-- Emp Code -->
            <div *ngIf="showEmpCode=== true" class="dropdownFields">
                <label>Employee Code</label>
                <input type="text" class="form-control" formControlName="EMPLOYEE_CODE" placeholder="Enter Employee Code">
            </div>

            <!-- Department -->
            <div *ngIf="showDepartment=== true" class="dropdownFields">
                <label>Department</label>
                <ng-select [multiple]="true" formControlName="DEPARTMENT_ID_IN" placeholder="Department" appendTo="body">
                    <ng-option *ngFor="let item of departmentList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
            
            <!-- Designation -->
            <div *ngIf="showDesignation=== true" class="dropdownFields">
                <label>Designation</label>
                <ng-select [multiple]="true" formControlName="DESIGNATION_IN" placeholder="Designation" appendTo="body">
                    <ng-option *ngFor="let item of designationList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Employee -->
            <div *ngIf="showEmployee=== true && role === 'SuperAdmin'" class="dropdownFields">
                <label>Employee</label>
                <ng-select [multiple]="true" formControlName="USER_ID" placeholder="Employee" appendTo="body">
                    <ng-option *ngFor="let item of employeeLists" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Project Owner -->
            <div *ngIf="showProjectOwner=== true" class="dropdownFields">
                <label>Project Owner</label>
                <ng-select [multiple]="true" formControlName="USER_ID_IN" placeholder="Project Owner" appendTo="body">
                    <ng-option *ngFor="let item of employeeLists" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Project Manager -->
            <div *ngIf="showProjectManager=== true" class="dropdownFields">
                <label>Project Manager</label>
                <ng-select [multiple]="true" formControlName="EMPLOYEE_ID_IN" placeholder="Project Manager" appendTo="body">
                    <ng-option *ngFor="let item of employeeLists" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- HOD -->
            <div *ngIf="showHod=== true" class="dropdownFields">
                <label>HOD</label>
                <ng-select [multiple]="true" formControlName="HOD_ID_IN" placeholder="HOD" appendTo="body">
                    <ng-option *ngFor="let item of employeeLists" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Project -->
            <div *ngIf="showProject=== true" class="dropdownFields">
                <label>Project</label>
                <ng-select [multiple]="true" formControlName="PROJECT_CODE_IN" placeholder="Project" appendTo="body">
                    <ng-option *ngFor="let item of projectLists" [value]="item.id">{{item.projectName}}</ng-option>
                </ng-select>
            </div>

            <!-- Designation -->
            <div *ngIf="showPriority=== true" class="dropdownFields">
                <label>Priority</label>
                <ng-select [multiple]="true" formControlName="PRIORITY_ID_IN" placeholder="Priority" appendTo="body">
                    <ng-option *ngFor="let item of priorityList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Category -->
            <div *ngIf="showCategory=== true" class="dropdownFields">
                <label>Category</label>
                <ng-select [multiple]="true" formControlName="CATEGORY_IN" placeholder="Priority" appendTo="body">
                    <ng-option *ngFor="let item of categoryList" [value]="item.id">{{item.categoryName}}</ng-option>
                </ng-select>
            </div>

            <!-- Project Category -->
            <div *ngIf="showProjectCategory=== true" class="dropdownFields">
                <label>Project Category</label>
                <ng-select [multiple]="true" formControlName="CATEGORY_IN" placeholder="Priority" appendTo="body">
                    <ng-option *ngFor="let item of projectCategoryList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Project Category -->
            <div *ngIf="showLocationType=== true" class="dropdownFields">
                <label>Location Type</label>
                <ng-select [multiple]="true" formControlName="LOCATION_TYPE_IN" placeholder="Location Type" appendTo="body">
                    <ng-option *ngFor="let item of locationTypeList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Zone -->
            <div *ngIf="showZone=== true" class="dropdownFields">
                <label>Zone</label>
                <ng-select [multiple]="true" formControlName="ZONE_IN" placeholder="zone" appendTo="body">
                    <ng-option *ngFor="let item of zoneList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Region -->
            <div *ngIf="showRegion=== true" class="dropdownFields">
                <label>Region</label>
                <ng-select [multiple]="true" formControlName="REGION_IN" placeholder="region" appendTo="body">
                    <ng-option *ngFor="let item of regionList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
            <!-- City  -->
            <div *ngIf="showCity=== true" class="dropdownFields">
                <label>City</label>
                <ng-select [multiple]="true" formControlName="CITY" placeholder="City" appendTo="body">
                    <ng-option *ngFor="let item of cityList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Expenses Type -->
            <div *ngIf="showExpenseType === true" class="dropdownFields">
                <label>Expenses Type</label>
                <ng-select [multiple]="true" formControlName="EXPENSE_TYPE_IN" placeholder="expense type" appendTo="body">
                    <ng-option *ngFor="let item of expenseTypeList" [value]="item.id">{{item.expenseName}}</ng-option>
                </ng-select>
            </div>

            <!-- Financial Year -->
            <div *ngIf="showFY === true" class="dropdownFields">
                <label>Financial Year</label>
                <ng-select [multiple]="true" formControlName="YEAR_IN" placeholder="financial year"
                    appendTo="body">
                    <ng-option *ngFor="let item of financialYearList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
            <!-- Month -->
            <div *ngIf="showMonth === true" class="dropdownFields readonlyfield">
                <label>Month</label>
                <p-calendar
                    (onSelect)="setMonth($event)"
                    formControlName="DUMMY_FILTER_TWO"
                    view="month"
                    dateFormat="MM"
                    [readonlyInput]="true"
                    inputId="monthpicker"
                    appendTo="body"
                ></p-calendar>
            </div>

            <!--Billing Type -->
            <div *ngIf="showBillingType === true" class="dropdownFields">
                <label>Billing Type</label>
                <ng-select [multiple]="true" formControlName="BILLINGTYPE" placeholder="billing type" appendTo="body">
                    <ng-option value="Fixed">Fixed</ng-option>
                    <ng-option value="Variable">Variable</ng-option>
                    <ng-option value="Credit Note">Credit Note</ng-option>
                    <ng-option value="Unbilled">Unbilled</ng-option>
                </ng-select>
            </div>

            <!-- Units of Measurement -->
            <div *ngIf="showUnitsOfMeasurement === true" class="dropdownFields">
                <label>Units of Measurement</label>
                <ng-select [multiple]="true" formControlName="UNITOFMEASUREMENT" placeholder="unit of measurement"
                    appendTo="body">
                    <ng-option value="BAGS">BAGS</ng-option>
                    <ng-option value="BOX">BOX</ng-option>
                    <ng-option value="KG">KG</ng-option>
                    <ng-option value="LINE">LINE</ng-option>
                    <ng-option value="LITER">LITER</ng-option>
                </ng-select>
            </div>

            <!-- Expenses Head -->
            <div *ngIf="showExpensesHead === true" class="dropdownFields">
                <label>Expenses</label>
                <ng-select [multiple]="true" formControlName="EXPENSESHEAD" placeholder="expenses head" appendTo="body">
                    <ng-option value="courierCharges">Capex-Interest</ng-option>
                    <ng-option value="dieselConsumption">Courier Charges-[Cash]</ng-option>
                    <ng-option value="dieselConsumption">Courier Charges-[Corporate]</ng-option>
                    <ng-option value="drinkingWaterChanges">Diesel Consumption[Cash]</ng-option>
                    <ng-option value="drinkingWaterChanges">Diesel Consumption[Corporate]</ng-option>
                </ng-select>
            </div>

            <!-- Invoice Status -->
            <div *ngIf="showInvoiceStatus === true" class="dropdownFields">
                <label>Invoice Status</label>
                <ng-select [multiple]="true" formControlName="INVOICESTATUS" placeholder="invoice status"
                    appendTo="body">
                    <ng-option value="withinBudget">Within Budget</ng-option>
                    <ng-option value="overrun">Overrun</ng-option>
                </ng-select>
            </div>
            <!-- Vendor -->
            <div *ngIf="showVendor === true" class="dropdownFields">
                <label>Vendor</label>
                <ng-select [multiple]="true" formControlName="VENDOR" placeholder="vendor"
                    appendTo="body">
                    <ng-option value="select">select</ng-option>
                    <ng-option value="select">select</ng-option>
                </ng-select>
            </div>

              <!-- Status Dropdown (Visible based on Input) -->
            <div *ngIf="showStatus === true" class="dropdownFields">
                <label>Status</label>
                <ng-select formControlName="STATUS_IN" placeholder="Select status" appendTo="body">
                    <ng-option [value]="1">Active</ng-option>
                    <ng-option [value]="0">Inactive</ng-option>
                </ng-select>
            </div>

            <!-- Worklog status -->
            <div *ngIf="showWorklogStatus === true" class="dropdownFields">
                <label>Status</label>
                <ng-select [multiple]="false" formControlName="STATUS_IN" placeholder="Status" appendTo="body">
                    <ng-option *ngFor="let item of worklogStatus" [value]="item.status">{{item.statusDescription}}</ng-option>
                </ng-select>
            </div>

            <!-- Project status -->
            <div *ngIf="showProjectStatus === true" class="dropdownFields">
                <label>Status</label>
                <ng-select [multiple]="false" formControlName="STATUS_IN" placeholder="Status" appendTo="body">
                    <ng-option *ngFor="let item of projectStatus" [value]="item.status">{{item.statusDescription}}</ng-option>
                </ng-select>
            </div>

            <div *ngIf="showDateFilter" class="dropdownFields">
                <label>Created At</label>
                <select class="form-control" name="createdAt" formControlName="DUMMY_FILTER_ONE" [(ngModel)]="selectedOption" (change)="onOptionChange($event)">
                  <option value="">All</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last-week">Last Week</option>
                  <option value="last-month">Last Month</option>
                  <option value="current-month">Current Month</option>
                  <option value="custom">Custom Date Range</option>
                </select>
                <div class="custom-wrapper" *ngIf="showCustomDateRange">
                  <div>
                    <label for="fromDate">From Date:</label>
                    <input class="form-control" name="fromDate" formControlName="FROM_DATE" type="datetime-local"/>
                  </div>
                  <div>
                    <label for="toDate">To Date:</label>
                    <input class="form-control"  name="toDate" formControlName="TO_DATE" type="datetime-local" />
                  </div>
                </div>
              </div>

              <!-- <div *ngIf="showCategory===true" class="dropdownFields">
                <p-multiSelect [options]="category" formControlName="CATEGORY" placeholder="category" optionLabel="categoryName" optionValue="id"></p-multiSelect>
              </div> -->

            <!-- Action Buttons -->
            <div class="advance-icon">
                <button class="btn reset-btn btn-cancel" type="button" (click)="onReset()">Reset</button>
                <button class="btn btn-primary ms-1" type="submit">Search</button>
            </div>
        </form>
    </div>
</div>